// import DeleteIcon from '@mui/icons-material/Delete';
// import DoneIcon from '@mui/icons-material/Done';
// import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
// import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import useUsers from '../../Hooks/useUsers';
// import { decryptData, decryptedBody, DESCRYPTION_TYPE, encryptData } from '../../Utils/constant';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { useNavigate } from 'react-router-dom';
// import moment from 'moment';
// import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
// import HistoryIcon from '@mui/icons-material/History';

// const AppUsers = () => {

//     const [users, setUsers] = useState([]);
//     const [userProducts, setUserProducts] = useState({});

//     const [deleteConfirm, setDeleteConfirm] = useState(false);
//     const [deleteId, setDeleteId] = useState(null);

//     const [userProductModal, setUserProductModal] = useState(false);

//     const [userHistoryModal, setUserHistoryModal] = useState(false);
//     const navigate = useNavigate();

//     const { getUsers, deleteUser, getUserProducts } = useUsers()

//     useEffect(() => {
//         fetchUsers()
//     }, [])

//     const fetchUsers = async () => {
//         const temp = await getUsers();
//         const res = decryptedBody(temp.data.data)
//         setUsers(res)
//     }

//     const deleteProducts = async (id) => {
//         await deleteUser(id)
//         fetchUsers();
//         setDeleteConfirm(false)
//     }

//     const fetchUserProduct = async (id) => {
//         const temp = await getUserProducts(id);
//         if (temp.data.data) {
//             const obj = temp.data.data;
//             const res = {
//                 mac_id: decryptData(obj.mac_id, DESCRYPTION_TYPE.STRING),
//                 version: decryptData(obj.version, DESCRYPTION_TYPE.STRING),
//                 color: decryptData(obj.color, DESCRYPTION_TYPE.STRING),
//                 type: decryptData(obj.type, DESCRYPTION_TYPE.STRING),
//             }
//             setUserProducts(res);
//         }
//     }

//     const fetchUserHistory = () => {

//     }

//     return (
//         <Grid>
//             <Grid display="flex" justifyContent="flex-end" marginBottom={2}>
//                 <Button variant="contained">
//                     Add User
//                 </Button>
//             </Grid>

//             <Grid className="product__page">
//                 <TableContainer component={Paper}>
//                     <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
//                         <TableHead>
//                             <TableRow>
//                                 {['Fristname', 'Last name', 'Email', 'Phone', 'Verified', 'Created At', 'Action'].map((header) => (
//                                     <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                                 ))}
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {users.map((row) => (
//                                 <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                     <TableCell align="left">{row.firstname}</TableCell>
//                                     <TableCell align="left">{row.lastname}</TableCell>
//                                     <TableCell align="left">{row.email}</TableCell>
//                                     <TableCell align="left">{row.phone}</TableCell>
//                                     <TableCell align="left">{row.isVerify ?
//                                         <Tooltip title="Done">
//                                             <DoneIcon />
//                                         </Tooltip>
//                                         :
//                                         <Tooltip title="Pending">
//                                             <HourglassEmptyIcon />
//                                         </Tooltip>
//                                     }</TableCell>
//                                     <TableCell align="left">{moment(row.createdAt).format('LLL')}</TableCell>
//                                     <TableCell align="left">
//                                         <IconButton onClick={() => {
//                                             const email = encryptData(row.email);
//                                             navigate(`/events`, { state: { email, firstname: row.firstname, lastname: row.lastname } });
//                                         }}>
//                                             <VisibilityIcon />
//                                         </IconButton>
//                                         <IconButton onClick={() => { fetchUserProduct(row.id); setUserProductModal(true); }}>
//                                             <QrCodeScannerIcon />
//                                         </IconButton>

//                                         <IconButton onClick={() => { fetchUserHistory(row.id); setUserHistoryModal(true); }}>
//                                             <HistoryIcon />
//                                         </IconButton>

//                                         <IconButton onClick={() => { setDeleteConfirm(true); setDeleteId(row.email); }}>
//                                             <DeleteIcon />
//                                         </IconButton>
//                                     </TableCell>

//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             </Grid>

//             {/* DELETE CONFIRM */}
//             <Dialog open={deleteConfirm} onClose={() => setDeleteConfirm(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
//                 <DialogTitle id="alert-dialog-title">Delete User</DialogTitle>
//                 <DialogContent>
//                     This action can't be reverted.
//                     Are you sure you want to delete this user?
//                 </DialogContent>
//                 <DialogActions>
//                     <Button size='small' variant='contained' onClick={() => deleteProducts(deleteId)}>
//                         <DeleteIcon style={{ width: '20px', marginRight: '5px' }} />
//                         Delete
//                     </Button>
//                     <Button size='small' variant='outlined' onClick={() => setDeleteConfirm(false)}>Close</Button>
//                 </DialogActions>
//             </Dialog>

//             {/* USER PRODUCT LIST */}
//             <Dialog open={userProductModal} minWidth={950} onClose={() => setUserProductModal(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
//                 <DialogTitle id="alert-dialog-title">User products</DialogTitle>
//                 <DialogContent>
//                     <TableContainer component={Paper}>
//                         <Table aria-label="simple table">
//                             <TableHead>
//                                 <TableRow>
//                                     {['Mac ID', 'Color', 'Type', 'Version'].map((header) => (
//                                         <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                                     ))}
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>

//                                 <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                     <TableCell align="left">{userProducts.mac_id}</TableCell>
//                                     <TableCell align="left">{userProducts.color}</TableCell>
//                                     <TableCell align="left">{userProducts.type}</TableCell>
//                                     <TableCell align="left">{userProducts.version}</TableCell>
//                                 </TableRow>

//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button size='small' variant='outlined' onClick={() => setUserProductModal(false)}>Close</Button>
//                 </DialogActions>
//             </Dialog>

//             {/* USER HISTORY LIST */}
//             <Dialog open={userHistoryModal} fullWidth onClose={() => setUserHistoryModal(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
//                 <DialogTitle id="alert-dialog-title">User history</DialogTitle>
//                 <DialogContent>
//                     <TableContainer component={Paper}>
//                         <Table aria-label="simple table">
//                             <TableHead>
//                                 <TableRow>
//                                     {['Deleted On', 'Reason'].map((header) => (
//                                         <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                                     ))}
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 ** UNDER DEVELOPMENT **

//                                 {/* <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                     <TableCell align="left">{userProducts.mac_id}</TableCell>
//                                     <TableCell align="left">{userProducts.color}</TableCell>
//                                     <TableCell align="left">{userProducts.type}</TableCell>
//                                     <TableCell align="left">{userProducts.version}</TableCell>
//                                 </TableRow> */}

//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button size='small' variant='outlined' onClick={() => setUserHistoryModal(false)}>Close</Button>
//                 </DialogActions>
//             </Dialog>
//         </Grid>
//     )
// }

// export default AppUsers
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  TablePagination,
  Box,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useUsers from "../../Hooks/useUsers";
import {
  decryptData,
  decryptedBody,
  DESCRYPTION_TYPE,
  encryptData,
} from "../../Utils/constant";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import HistoryIcon from "@mui/icons-material/History";
import PageHeader from "../../Components/UI/PageHeader";
import SectionCard from "../../Components/UI/SectionCard";

const AppUsers = () => {
  const [users, setUsers] = useState([]);
  const [userProducts, setUserProducts] = useState({});
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [userProductModal, setUserProductModal] = useState(false);
  const [userHistoryModal, setUserHistoryModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 10;

  const navigate = useNavigate();
  const { getUsers, deleteUser, getUserProducts, archiveUser } = useUsers();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const temp = await getUsers();
    const res = decryptedBody(temp.data.data);
    setUsers(res);
  };

  const deleteProducts = async (id) => {
    try {
      const res = await deleteUser(id);
      const msg =
        res?.data?.message ||
        (res?.data?.data?.success
          ? "User deleted"
          : "User delete request processed");
      toast.success(msg);
      await fetchUsers();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("deleteUser failed:", err);
      const msg =
        err?.response?.data?.message || "Failed to delete user";
      toast.error(msg);
    } finally {
      setDeleteConfirm(false);
    }
  };

  const fetchUserProduct = async (id) => {
    const temp = await getUserProducts(id);
    if (temp.data.data) {
      const obj = temp.data.data;
      const res = {
        mac_id: decryptData(obj.mac_id, DESCRYPTION_TYPE.STRING),
        version: decryptData(obj.version, DESCRYPTION_TYPE.STRING),
        color: decryptData(obj.color, DESCRYPTION_TYPE.STRING),
        type: decryptData(obj.type, DESCRYPTION_TYPE.STRING),
      };
      setUserProducts(res);
    }
  };

  const fetchUserHistory = () => {
    // User history logic here
  };

  const paginatedUsers = users.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage,
  );

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <PageHeader
        title="Users"
        subtitle="Manage app users, view their events, and inspect assigned products."
        actions={[
          { label: "Add user", key: "add", variant: "outlined" },
          {
            label: "Archived users",
            key: "archived",
            onClick: () => navigate("/archived-users"),
          },
        ]}
      />

      <SectionCard
        title="Active users"
        subtitle={`Total: ${users.length}`}
        right={
          <Stack direction="row" spacing={1}>
            <Button variant="contained" onClick={() => fetchUsers()}>
              Refresh
            </Button>
          </Stack>
        }
      >
        <Box sx={{ overflowX: "auto" }}>
          <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
            <Table stickyHeader sx={{ minWidth: 900 }} aria-label="users table">
              <TableHead>
                <TableRow>
                  {[
                    "Firstname",
                    "Last name",
                    "Email",
                    "Phone",
                    "Verified",
                    "Created At",
                    "Action",
                  ].map((header) => (
                    <TableCell key={header} sx={{ fontWeight: 800 }} align="left">
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedUsers.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell align="left">{row.firstname}</TableCell>
                    <TableCell align="left">{row.lastname}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.phone}</TableCell>
                    <TableCell align="left">
                      {row.isVerify ? (
                        <Tooltip title="Verified">
                          <DoneIcon fontSize="small" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Pending">
                          <HourglassEmptyIcon fontSize="small" />
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell align="left">{moment(row.createdAt).format("LLL")}</TableCell>
                    <TableCell align="left">
                      <Tooltip title="Events">
                        <IconButton
                          size="small"
                          onClick={() => {
                            const email = encryptData(row.email);
                            navigate(`/events`, {
                              state: {
                                email,
                                firstname: row.firstname,
                                lastname: row.lastname,
                              },
                            });
                          }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Products">
                        <IconButton
                          size="small"
                          onClick={() => {
                            fetchUserProduct(row.id);
                            setUserProductModal(true);
                          }}
                        >
                          <QrCodeScannerIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="History (WIP)">
                        <IconButton
                          size="small"
                          onClick={() => {
                            fetchUserHistory(row.id);
                            setUserHistoryModal(true);
                          }}
                        >
                          <HistoryIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Delete">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setDeleteConfirm(true);
                            setDeleteId(row.email);
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {users.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No users found.
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={users.length}
            page={currentPage}
            onPageChange={(e, newPage) => setCurrentPage(newPage)}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[10]}
          />
        </Box>
      </SectionCard>

      {/* DELETE CONFIRM */}
      <Dialog open={deleteConfirm} onClose={() => setDeleteConfirm(false)}>
        <DialogTitle>Delete User</DialogTitle>
        <DialogContent>
          This action can't be reverted. Are you sure you want to delete this
          user?
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="contained"
            onClick={() => deleteProducts(deleteId)}
          >
            <DeleteIcon style={{ width: "20px", marginRight: "5px" }} />
            Delete
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setDeleteConfirm(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* USER PRODUCT LIST */}
      <Dialog
        open={userProductModal}
        onClose={() => setUserProductModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>User Products</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {["Mac ID", "Color", "Type", "Version"].map((header) => (
                    <TableCell
                      key={header}
                      style={{ fontWeight: "bold" }}
                      align="left"
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="left">{userProducts.mac_id}</TableCell>
                  <TableCell align="left">{userProducts.color}</TableCell>
                  <TableCell align="left">{userProducts.type}</TableCell>
                  <TableCell align="left">{userProducts.version}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setUserProductModal(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* USER HISTORY LIST */}
      <Dialog
        open={userHistoryModal}
        fullWidth
        maxWidth="lg"
        onClose={() => setUserHistoryModal(false)}
      >
        <DialogTitle>User History</DialogTitle>
        <DialogContent>{/* Under development section */}</DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setUserHistoryModal(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AppUsers;
